import React from 'react'

const Fullscreen = ({ style, ...props }) => {
  return null
}

export default Fullscreen
